import {linkifyText} from '@/shared/lib/legal/linkifyText';

import {type TextItem} from './types';

type TextItemViewProps = {
  content: TextItem['content'];
};

function TextContentView({content}: TextItemViewProps) {
  return <p>{linkifyText(content)}</p>;
}

export default TextContentView;
